import { render, staticRenderFns } from "./CategoryContextMenu.vue?vue&type=template&id=90294c6e&scoped=true&"
import script from "./CategoryContextMenu.vue?vue&type=script&lang=js&"
export * from "./CategoryContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./CategoryContextMenu.vue?vue&type=style&index=0&id=90294c6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90294c6e",
  null
  
)

export default component.exports